class Util {

	static getViewportWidth() {
		return Math.max( document.documentElement.clientWidth, window.innerWidth || 0 );
	}

	static scrollTo( target, offset = 0, speed = 1000 ) {

		target = jQuery( target );
		if ( 0 === target.length ) {
			return;
		}

		jQuery( document ).trigger( 'suma:beforeScrolledto', [ target ] );

		/*
		Added `promise()` to ensure callback only fires once
		despite running `animate` on multiple elements.
		 */
		jQuery( 'html, body' ).animate(
			{
				scrollTop: target.offset().top + offset
			},
			speed,
			'swing'
		).promise().then(
			() => {
				jQuery( document ).trigger( 'suma:scrolledto', [ target ] );
			}
		);
	}

	static getHeaderHeight() {

		// We can store the height because it doesn't change on scroll
		let height = window.header_height;

		if ( undefined === height ) {

			height = 0;

			const header = document.querySelector( 'header.main-header' );

			height += header.offsetHeight;
			height += Util.getAdminBarHeight();

			window.header_height = height;
		}

		return height;
	}

	static getAdminBarHeight() {
		const adminBar = document.getElementById( 'wpadminbar' );
		if ( adminBar != null ) {
			return adminBar.offsetHeight;
		}
		return 0;
	}

	static getQueryParam( name, url ) {

		if ( ! url ) {
			url = window.location.href;
		};

		name        = name.replace( /[\[\]]/g, '\\$&' );
		let regex   = new RegExp( '[?&]' + name + '(=([^&#]*)|&|#|$)' );
		let results = regex.exec( url );

		if ( ! results ) {
			return null;
		}
		if ( ! results[ 2 ] ) {
			return '';
		}

		return decodeURIComponent( results[ 2 ].replace( /\+/g, ' ' ) );
	}

	 static luhnCheck(ccNum) {
		 let
			arr = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9],
			len = ccNum.length,
			bit = 1,
			sum = 0,
			val;

		 while (len) {
			 val = parseInt(ccNum.charAt(--len), 10);
			 sum += (bit ^= 1) ? arr[val] : val;
		 }

		 return sum && sum % 10 === 0;
	};

	static createDebouncer () {

		let timeout = null;

		return function ( callback, delay) {

			clearTimeout(timeout);

			timeout = setTimeout(() => {
				callback();
			}, delay || 500);
		};
	}

	static translate($key){
		if(typeof suma_elementor_translations !== 'undefined' && suma_elementor_translations[$key]) {
			return suma_elementor_translations[$key];
		} else{
			return $key;
		}
	}

}

export default Util;
